<template>
  <div>
    <div class="row">
      <div class="col col-sm-6">
        <div class="row">
          <div class="col">
            <div class="alert alert-primary group-title">
              <icon :icon="['fad', 'university']"/>
              {{_[abstract.setting_submission_id].institute.header}}
            </div>
          </div>
        </div>
        <div class="row" v-if="author">
          <div class="col text-muted">{{_[abstract.setting_submission_id].institute.header_author}} {{author.firstname}}
            {{author.lastname}}
          </div>
        </div>
        <div class="row mt-3"
             v-if="_[abstract.setting_submission_id].institute.info_top && _[abstract.setting_submission_id].institute.info_top.length > 2">
          <div class="col">
            <speaker :submission_id="abstract.setting_submission_id" area="institute" textkey="info_top"></speaker>
          </div>
        </div>
        <entitegenerator v-if="institute"
                         :entities="entitiesInstitute" :values="institute"
                         :system="{main: 'submission', action: 'create'}"
                         :models="{'countries':countryData()}"
                         :error="error"
                         :language="language"
                         mode="formular"
                         class="mb-3"
                         :mode="editorStyle">
          <!--mode="formular">-->

        </entitegenerator>
      </div>
      <div class="col offset-sm-1" v-if="!editInstitute">
        <div class="row mb-3" v-if="settings.authors.institutes.google">
          <div class="col">
            <GooglePlaces></GooglePlaces>
          </div>
        </div>
        <div class="row" v-if="settings.authors.institutes.previouslist">
          <div class="col">
            <PreviousInstituteList @cloneInstitute="cloneInstitute"></PreviousInstituteList>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" v-if="!editInstitute && processing.institute === false">
      <div class="col d-flex" v-if="!abstract.edited">
        <router-link :to="'/abstract/' + this.$route.params.id + '/'+routeDestination">
          <button type="button" class="btn btn-info">
            <icon :icon="['fas', 'angle-left']"/>&nbsp;{{_[abstract.setting_submission_id].institute.button_back_no_save}}
          </button>
        </router-link>
      </div>

      <div class="col d-flex" v-if="settings.authors.max_institutes > 1 && settings.authors.max_institutes > institutes.length +1">
        <button type="button" class="btn btn-success" v-on:click="createandnext('newinstitute')">
          <icon :icon="['fad', 'university']"/>&nbsp;{{_[abstract.setting_submission_id].institute.button_add_institute_with_save}}
        </button>
      </div>
      <div class="w-100 d-block d-sm-none mt-2"></div>
      <div class="col d-flex">
        <button type="button" class="btn btn-success" v-if="settings.authors.max_authors > authors.length+1"
                v-on:click="createandnext('../../../../authors/author/add')">
          <icon :icon="['fad', 'user-plus']"/>&nbsp;{{_[abstract.setting_submission_id].institute.button_add_author_with_save}}
        </button>
      </div>
      <div class="col d-flex">
        <button type="button" class="btn btn-success" v-on:click="createandnext('../../../../'+routeDestination)">
          <icon :icon="['fal', 'save']"/>&nbsp;{{_[abstract.setting_submission_id].institute.button_back_with_save}}
        </button>
      </div>
    </div>
    <div class="row mt-3" v-else-if="processing.institute === false">
      <div class="col d-flex">
        <router-link :to="'/abstract/' + this.$route.params.id + '/'+routeDestination" class="mr-auto">
          <button type="button" class="btn btn-success">
            <icon :icon="['fas', 'angle-left']"/>&nbsp;{{_[abstract.setting_submission_id].institute.button_back_no_save}}
          </button>
        </router-link>
        <button type="button" class="btn btn-success ml-1"
                v-on:click="saveandnext('../../../../../' + routeDestination)">
          <icon :icon="['fal', 'save']"/>&nbsp;{{_[abstract.setting_submission_id].institute.button_back_with_save}}
        </button>
      </div>
    </div>
    <div v-else-if="processing.institute === true">
      <ProcessingButton></ProcessingButton>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapState} from 'vuex'
  import entitegenerator from 'entite-generator';
  import GooglePlaces from "./GooglePlaces";
  import PreviousInstituteList from "./PreviousInstituteList";


  export default {
    name: "Instituteform",
    components: {PreviousInstituteList, GooglePlaces, entitegenerator},
    data() {
      return {
        noSaveNext: null,
        editFormular: false,
        editInstitute: false,
        error: {}
      };
    },
    created() {
      if (this.$route.params.instituteid) {
        this.editInstitute = true;
        this.GET_ONE_INSTITUTE(this.$route.params.instituteid);
      } else {
        this.$store.commit('SET_INSTITUTE', {"institute": {}});
      }
    },
    computed: {
      ...mapState([
        'abstract',
        'authors',
        'author',
        'institute',
        'institutes',
        'wording',
        'processing',
        'settings',
        'user',
        'mode',
        "language"
      ]),
      routeDestination: function () {
        if (this.mode.confirm === true) {
          return 'confirm';
        }
        return 'authors';
      },
      entitiesInstitute: function () {
        let role = 'coauthor';
        if (this.author && this.author.role_id === 2) {
          role = 'presenter';
        }
        return this.$store.getters.getCurrentPageByType(this.abstract.setting_submission_id, 2).entity[role].institute;
      },
      editorStyle() {
        let mystyle = "formular"
        if(this.$store.getters.getCurrentPageByType(this.abstract.setting_submission_id, 2).readonly && this.$store.getters.getCurrentPageByType(this.abstract.setting_submission_id, 2).readonly == true){
          mystyle = "preview"
        }
        return mystyle;
      },
    },
    methods: {
      ...mapActions([
        'VALIDATE_TARGET', 'CREATE_INSTITUTE', 'PUT_INSTITUTE', 'GET_ONE_INSTITUTE', 'GET_AUTHORS_RESPONSE', 'GET_INSTITUTES_RESPONSE'
      ]),
      cloneInstitute(newInstitute) {
        let cloneobject = Object.assign({}, newInstitute);
        delete cloneobject['id'];
        delete cloneobject['author_id'];
        delete cloneobject['order'];
        delete cloneobject['created_at'];
        delete cloneobject['updated_at'];
        delete cloneobject['deleted_at'];
        this.$store.dispatch('IMPLODE_ADDITIONAL_INSTITUTE_DATA', cloneobject);
      },
      createandnext: async function (route) {
        this.processing.institute = true;
        let target = this.abstract.setting_submission_id + '/';
        target += this.author.role_id === 2 ? 'presenter/institute' : 'coauthor/institute';
        let data = {
          template: this.institute,
          target: target
        };
        data.template.author_id = this.author.id;
        data.template.order = this.institutes.length + 1;
        let sendInstitute = false;
        await this.VALIDATE_TARGET(data).then((result) => {
          sendInstitute = true;
          this.error = {};
        }).catch((error) => {
          this.processing.institute = false;
          this.noSaveNext = null;
          this.$noty.error(this.wording[0].notify.validation_error);
          this.error = error.response.data;
          sendInstitute = false;
        })

        if (!sendInstitute) return;
        await this.CREATE_INSTITUTE(data).then((result) => {
          this.$noty.success(this.wording[0].notify.save_success);
          if (route === 'newinstitute') {
            this.$store.commit('SET_INSTITUTE', {"institute": {}});
          }
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.save_not_success);
        })

        await this.GET_INSTITUTES_RESPONSE(this.author.id).then((resultInstitutes) => {
          this.$store.commit('SET_INSTITUTES', {institutes: resultInstitutes.data})
        })

        if (route === 'newinstitute') {
          this.processing.institute = false;
          return;
        }
        await this.GET_AUTHORS_RESPONSE(this.abstract.id).then((response) => {
          this.processing.institute = false;
          this.$store.commit('SET_AUTHORS', {authors: response.data});
          this.$router.push(route);
        }).catch((error) => {
        })
      },
      saveandnext: async function (route) {
        this.processing.institute = true;
        let target = this.abstract.setting_submission_id + '/';
        target += this.author.role_id === 2 ? 'presenter/institute' : 'coauthor/institute';
        let data = {
          id: this.institute.id,
          template: this.institute,
          target: target
        };
        let sendInstitute = false;
        await this.VALIDATE_TARGET(data).then((result) => {
          this.error = {};
          sendInstitute = true;
        }).catch((error) => {
          this.processing.institute = false;
          this.noSaveNext = null;
          this.$noty.error(this.wording[0].notify.validation_error);
          this.error = error.response.data;
          sendInstitute = false;
        })

        if (!sendInstitute) return;
        await this.PUT_INSTITUTE(data).then((result) => {
          this.$noty.success(this.wording[0].notify.save_success);
          this.processing.institute = false;
          if (route === 'newinstitute') {
            this.$store.commit('SET_INSTITUTE', {"institute": {}});
            this.$router.push('../add');
          } else {
            this.$router.push(route);
          }
        }).catch((error) => {
          this.processing.institute = false;
          this.$noty.error(this.wording[0].notify.save_not_success);
        })

      }
    }
    , beforeRouteLeave(to, from, next) {
      if (!this.abstract.edited) {
        next()
      } else {
        if (!this.noSaveNext) {
          this.noSaveNext = to;
          if (this.editInstitute) {
            this.saveandnext(to)
          } else {
            next()
          }
        } else {
          this.noSaveNext = null;
          this.processing.institute = false;
          next()
        }
      }
    }
  }
</script>
